"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenciesSuggestionType = void 0;
var AgenciesSuggestionType;
(function (AgenciesSuggestionType) {
    AgenciesSuggestionType["AGENCY"] = "agency";
    AgenciesSuggestionType["MAP_OBJECT"] = "map-object";
})(AgenciesSuggestionType || (exports.AgenciesSuggestionType = AgenciesSuggestionType = {}));
//# sourceMappingURL=fdr-agency-map-search.types.js.map